import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { ArrowRight, Stethoscope, DollarSign } from 'lucide-react';

const CrossAppDialog = ({ open, onOpenChange, targetApp, context }) => {
  const navigate = useNavigate();
  const isLumina = targetApp === 'lumina';
  const config = isLumina
    ? { icon: Stethoscope, title: 'Clinical Feature', desc: 'This action requires Lumina — the clinical documentation platform.', btn: 'Open Lumina', route: '/lumina', color: 'bg-slate-100 text-slate-800' }
    : { icon: DollarSign, title: 'Billing Feature', desc: 'This action requires revQ — the revenue cycle management platform.', btn: 'Open revQ', route: '/revq', color: 'bg-slate-100 text-slate-800' };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm p-0 overflow-hidden" data-testid="cross-app-dialog">
        <div className="bg-black p-5 text-white">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-xl bg-white/10 flex items-center justify-center"><config.icon className="h-5 w-5 text-white" /></div>
            <div>
              <DialogTitle className="text-base font-bold text-white">{config.title}</DialogTitle>
              <p className="text-xs text-slate-400 mt-0.5">{context || config.desc}</p>
            </div>
          </div>
          <DialogDescription className="sr-only">{config.desc}</DialogDescription>
        </div>
        <div className="p-5 space-y-3">
          <p className="text-sm text-slate-600">{config.desc}</p>
          <Button onClick={() => { onOpenChange(false); navigate(config.route); }} className="w-full bg-black hover:bg-gray-800 gap-2" data-testid="cross-app-go-btn">
            {config.btn} <ArrowRight className="h-4 w-4" />
          </Button>
          <Button variant="outline" onClick={() => onOpenChange(false)} className="w-full" data-testid="cross-app-stay-btn">Stay in Echo</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CrossAppDialog;
